import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export interface Jurisdiction
{
	id: string;
	name: string;
	disabled: boolean;
	timeZone: string;
	isPublic: boolean;
}

@Injectable()
export class CivilianJurisdictionRepository
{
	private requestMapping: string = "jurisdictions";
	private http: HttpClient;

	public constructor(http: HttpClient)
	{
		this.http = http;
	}

	public searchJurisdictionsByName(nameQuery: string): Observable<Jurisdiction[]>
	{
		return this.http.get<Jurisdiction[]>(`${this.requestMapping}/search?query=${nameQuery}`);
	}
}
